import { createApp, h } from 'vue';
import singleSpaVue from 'single-spa-vue';
import App from './App.vue';
import { handleInstance } from './bootstrap';
import { wrapSingleSpaLifeCycle } from './utils/singleSpa';

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App, {
        userStore: this.userStore,
        locale: this.locale,
        applyRouteSideEffects: this.applyRouteSideEffects ?? true,
      });
    },
  },
  handleInstance,
});

export const { bootstrap, mount, unmount } = wrapSingleSpaLifeCycle(vueLifecycles);
